// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../doc-site/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bolt-contextual-menu {
  border-radius: 4px;
  max-width: 320px;
  overflow-x: hidden;
  overflow-y: auto;
}
@media (forced-colors: active) {
  .bolt-contextual-menu {
    border: 1px solid;
  }
}

@media screen and (max-width: 599px) {
  .bolt-contextual-submenu {
    min-width: 200px;
  }
}

.overflow .bolt-contextual-menu {
  overflow-y: scroll;
}

.bolt-menu {
  border-collapse: separate;
  color: rgba(0, 0, 0, .9);
  color: var(--text-primary-color,rgba(0, 0, 0, .9));
  display: table;
  table-layout: auto;
  font-size: 0.875rem;
}

.bolt-menuitem-row {
  background-color: transparent;
  border-radius: 3px;
  color: inherit;
  display: table-row;
  outline: none;
  overflow: hidden;
  text-decoration: none;
  white-space: nowrap;
}
@media (forced-colors: active) {
  .bolt-menuitem-row {
    border: 1px solid transparent;
  }
}
.bolt-menuitem-row.focused {
  background-color: transparent;
  outline: none;
}
@media (forced-colors: active) {
  .bolt-menuitem-row.focused {
    border-color: windowtext;
    color: windowtext;
  }
}
.bolt-menuitem-row:hover, .bolt-menuitem-row.expanded {
  background-color: rgba(0, 0, 0, 0.04);
  background-color: var(--palette-black-alpha-4,rgba(0, 0, 0, 0.04));
}
@media (forced-colors: active) {
  .bolt-menuitem-row.expanded {
    border-color: windowtext;
  }
  .bolt-menuitem-row:hover {
    background-color: highlight;
  }
}
.bolt-menuitem-row.disabled {
  color: rgba(0, 0, 0, .38);
  color: var(--text-disabled-color,rgba(0, 0, 0, .38));
}
@media (forced-colors: active) {
  .bolt-menuitem-row.disabled {
    color: grayText;
  }
}
.bolt-menuitem-row.disabled:hover {
  background-color: transparent;
}

body.ms-vss-web-vsts-theme-hc-dark .bolt-menuitem-row:not(.bolt-menuitem-divider, .bolt-menuitem-header):hover, body.ms-vss-web-vsts-theme-hc-dark .bolt-menuitem-row:not(.bolt-menuitem-divider, .bolt-menuitem-header):focus {
  background-color: rgba(0, 120, 212, 1);
  background-color: var(--focus-border-color,rgba(0, 120, 212, 1));
  color: rgba(255, 255, 255, 1);
  color: var(--background-color,rgba(255, 255, 255, 1));
}
body.ms-vss-web-vsts-theme-hc-light .bolt-menuitem-row:not(.bolt-menuitem-divider, .bolt-menuitem-header):hover, body.ms-vss-web-vsts-theme-hc-light .bolt-menuitem-row:not(.bolt-menuitem-divider, .bolt-menuitem-header):focus {
  background-color: rgba(0, 120, 212, 1);
  background-color: var(--focus-border-color,rgba(0, 120, 212, 1));
  color: rgba(255, 255, 255, 1);
  color: var(--background-color,rgba(255, 255, 255, 1));
}

.bolt-focus-visible .bolt-menuitem-row.focused {
  animation: focus-shadow-pulse-inset 4s ease-in-out infinite;
  background-color: rgba(0, 0, 0, 0.04);
  background-color: var(--palette-black-alpha-4,rgba(0, 0, 0, 0.04));
  outline: none;
}

a.bolt-menuitem-row:not(.ms-Button),
a.bolt-menuitem-row:not(.ms-Button):visited,
a.bolt-menuitem-row:not(.ms-Button):hover {
  color: rgba(0, 0, 0, .9);
  color: var(--text-primary-color,rgba(0, 0, 0, .9));
  text-decoration: none;
}
@media (forced-colors: active) {
  a.bolt-menuitem-row:not(.ms-Button),
  a.bolt-menuitem-row:not(.ms-Button):visited,
  a.bolt-menuitem-row:not(.ms-Button):hover {
    color: windowtext;
  }
}

@media (forced-colors: active) {
  a.bolt-menuitem-row:not(.ms-Button):hover {
    color: highlighttext;
  }
}

@media (forced-colors: active) {
  a.bolt-menuitem-row .bolt-list-cell {
    border-color: transparent;
  }
}

@media (forced-colors: active) {
  a.bolt-menuitem-row:hover .bolt-list-cell {
    border-color: highlight;
  }
}

@media (forced-colors: active) {
  .bolt-focus-visible a.bolt-menuitem-row:focus .bolt-list-cell {
    border-color: highlight;
  }
}

.bolt-menuitem-header {
  font-weight: 600;
}

.bolt-menuitem-divider:hover,
.bolt-menuitem-header:hover {
  background-color: transparent;
}
@media (forced-colors: active) {
  .bolt-menuitem-divider:hover,
  .bolt-menuitem-header:hover {
    border: 1px solid transparent;
  }
}

.bolt-menuitem-cell {
  padding: 0;
  vertical-align: middle;
}
.bolt-menuitem-cell:first-child .bolt-menuitem-cell-content {
  padding-right: 0px;
}
.bolt-menuitem-cell:last-child .bolt-menuitem-cell-content {
  padding-left: 0px;
}

.bolt-menuitem-cell-content {
  justify-content: center;
  padding: 6px;
}

.bolt-menuitem-cell-text {
  justify-content: flex-start;
  max-width: 225px;
  min-width: 180px;
  white-space: normal;
  word-break: break-word;
}

.bolt-menuitem-cell-secondary {
  color: rgba(0, 0, 0, .55);
  color: var(--text-secondary-color,rgba(0, 0, 0, .55));
}

.bolt-menuitem-divider-content {
  background-color: rgba(0, 0, 0, 0.20);
  background-color: var(--palette-black-alpha-20,rgba(0, 0, 0, 0.20));
  height: 1px;
  margin: 6px 6px;
  padding: 0px;
}

.bolt-menu-spacer {
  padding: 4px;
}

body.ms-vss-web-vsts-theme-hc-dark .bolt-menuitem-row:hover .bolt-toggle-button-pill,
body.ms-vss-web-vsts-theme-hc-dark .bolt-menuitem-row:focus .bolt-toggle-button-pill {
  border-color: rgba(255, 255, 255, 1);
  border-color: var(--background-color,rgba(255, 255, 255, 1));
}
body.ms-vss-web-vsts-theme-hc-light .bolt-menuitem-row:hover .bolt-toggle-button-pill,
body.ms-vss-web-vsts-theme-hc-light .bolt-menuitem-row:focus .bolt-toggle-button-pill {
  border-color: rgba(255, 255, 255, 1);
  border-color: var(--background-color,rgba(255, 255, 255, 1));
}
body.ms-vss-web-vsts-theme-hc-dark .bolt-menuitem-row:hover .bolt-toggle-button-icon,
body.ms-vss-web-vsts-theme-hc-dark .bolt-menuitem-row:focus .bolt-toggle-button-icon {
  background-color: rgba(255, 255, 255, 1);
  background-color: var(--background-color,rgba(255, 255, 255, 1));
}
body.ms-vss-web-vsts-theme-hc-light .bolt-menuitem-row:hover .bolt-toggle-button-icon,
body.ms-vss-web-vsts-theme-hc-light .bolt-menuitem-row:focus .bolt-toggle-button-icon {
  background-color: rgba(255, 255, 255, 1);
  background-color: var(--background-color,rgba(255, 255, 255, 1));
}
body.ms-vss-web-vsts-theme-hc-dark .bolt-menuitem-row:hover .bolt-toggle-button-text,
body.ms-vss-web-vsts-theme-hc-dark .bolt-menuitem-row:focus .bolt-toggle-button-text {
  color: rgba(255, 255, 255, 1);
  color: var(--background-color,rgba(255, 255, 255, 1));
}
body.ms-vss-web-vsts-theme-hc-light .bolt-menuitem-row:hover .bolt-toggle-button-text,
body.ms-vss-web-vsts-theme-hc-light .bolt-menuitem-row:focus .bolt-toggle-button-text {
  color: rgba(255, 255, 255, 1);
  color: var(--background-color,rgba(255, 255, 255, 1));
}

/*# sourceMappingURL=Menu.css.map */
`, "",{"version":3,"sources":["webpack://./../azure-devops-ui/src/Components/Menu/Menu.scss","webpack://./../azure-devops-ui/bin/Components/Menu/Menu.css","webpack://./../azure-devops-ui/src/_coreStyles.scss","webpack://./../azure-devops-ui/src/Core/_platformCommon.scss"],"names":[],"mappings":"AACA;EACI,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;ACAJ;AC0CI;EF9CJ;IAOQ,iBAAA;ECCN;AACF;;AE0VI;EHxVJ;IAOQ,gBAAA;ECJN;AACF;;ADQA;EACI,kBAAA;ACLJ;;ADQA;EACI,yBAAA;EACA,wBG+HW;EH9HX,kDAAA;EACA,cAAA;EAGA,kBAAA;ECPF,mBAAmB;AACrB;;AAEA;EDSI,6BAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,qBAAA;ECPF,mBAAmB;ACQjB;ADNJ;EACE;IACE,6BAA6B;EAC/B;ADQE;ACNJ;EDQQ,6BAAA;ECNN,aAAa;ACDX;ADGJ;EACE;IDOU,wBAAA;ICLR,iBAAiB;EACnB;ADQE;ACNJ;EACE,qCAAqC;ECVnC,kEAAA;ADYJ;AACA;EACE;IDWM,wBAAA;ECTN;EACA;IACE,2BAA2B;EDY3B;ACVJ;AACA;ECrBI,yBAAA;EF8BA,oDAAA;ACNJ;AACA;EACE;IDWM,eAAA;EACI;ACTZ;AACA;EDgBQ,6BAAA;ACdR;;AAEA;EDYQ,sCAAA;EAEI,gEE5FS;EF6FT,6BGyDM;EFpEhB,qDAAqD;AACvD;ADeA;EACI,sCAAA;EACA,gEG8Bc;EH7Bd,6BAAA;ECbF,qDAAqD;AACvD;;ADgBA;EAAA,2DAAA;EAGI,qCG8CW;EH7CX,kEAAA;ECdF,aAAa;ACnDX;;AF6DJ;;;ECJE,wBAAwB;EACxB,kDAAkD;EAClD,qBAAqB;AC3DnB;AD6DJ;EACE;;;IAGE,iBAAiB;ECjEjB;ADmEJ;;AAEA;EACE;IACE,oBAAoB;ECvEpB;ADyEJ;;AAEA;EACE;IACE,yBAAyB;EC7EzB;AD+EJ;;AAEA;EACE;IACE,uBAAuB;EDmB3B;ACjBA;;AAEA;EDmBA;IAAA,uBAAA;EAEI;ACjBJ;;AAEA;EDaA,gBAAA;ACXA;;AAEA;;EDkBA,6BAAA;ACfA;AACA;EACE;;IDkBM,6BAAA;ECfN;ADkBE;;ACfJ;EACE,UAAU;EDmBZ,sBAAA;ACjBA;AACA;EACE,kBAAkB;AACpB;ADmBA;EACI,iBAAA;ACjBJ;;AAEA;EDmBI,uBAAA;ECjBF,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EDmBlB,gBAAA;EACI,mBG5Ee;EH6Ef,sBAAA;ACjBJ;;AAEA;EACE,yBAAyB;EDmB3B,qDAAA;ACjBA;;AAEA;EEkNQ,qCAAA;EAAA,mEAAA;EH1LI,WAAA;ECpBV,eAAe;EEiNT,YAAA;AAAA;;AF7MR;EE0MQ,YAAA;AAAA;;AFtMR;;EEyMQ,oCAAA;EHvLI,4DG7DM;AF+ClB;AEkMQ;;EH9KI,oCGnEM;EFmDhB,4DAA4D;AEiMtD;AAAA;;EF7LN,wCAAwC;EACxC,gEAAgE;AAClE;AACA;;EAEE,wCAAwC;EACxC,gEAAgE;AAClE;AACA;;EAEE,6BAA6B;EAC7B,qDAAqD;AACvD;AACA;;EAEE,6BAA6B;EAC7B,qDAAqD;AACvD;;AAEA,mCAAmC","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
